import React, { useState, useEffect, useContext } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Button, Grid, Snackbar, Alert,
  useTheme, useMediaQuery
} from "@mui/material";
import { ThemeContext } from "../../../../../../../../context/ThemeContextProvider";
import { useOrder } from "../../../../../../../../context/OrderCreator/TablesContext/OrderContext";

const EditOrderForm = ({ open, onClose, initialData }) => {
  const { mode } = useContext(ThemeContext);
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("sm")); // phones
  const isTablet = useMediaQuery("(min-width:600px) and (max-width:1200px)"); // tablets / iPad
  const controlSize = isTablet ? "medium" : isXs ? "small" : "small";
  const dialogWidth = isXs ? "100vw" : isTablet ? "90vw" : 720;
  const { updateOrderData } = useOrder(); // ✅ جلب الدالة من الـ Context

  const [form, setForm] = useState({});
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (initialData) setForm(initialData);
  }, [initialData]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    try {
      if (!form.order_id) throw new Error("❌ رقم الأوردر غير موجود");

      const updateData = {
        customer_name: form.customer_name,
        customer_phone1: form.customer_phone1,
        customer_phone2: form.customer_phone2,
        customer_phone3: form.customer_phone3,
        customer_address1: form.customer_address1,
        customer_address2: form.customer_address2,
        customer_id: form.customer_id || (form.customer?.id ?? ""),
        table_id: form.table_id || "",
      };

      // ✅ استخدم الدالة من الـ Context
      await updateOrderData(form.order_id, updateData);

      setSuccess(true);
      onClose(true);
    } catch (err) {
      let msg = "فشل في تعديل الأوردر: ";
      if (err?.message) msg += err.message;
      setError(msg);
    }
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={() => onClose(false)}
        fullScreen={isXs}
        maxWidth={false}
        PaperProps={{
          sx: {
            width: dialogWidth,
            maxWidth: "98vw",
            bgcolor: mode === "dark" ? "#232334" : "#fff",
            color: mode === "dark" ? "#fff" : "#232334",
            borderRadius: { xs: 0, sm: 3 },
          },
        }}
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
        >
          <DialogTitle
            sx={{
              fontWeight: 700,
              fontSize: 22,
              textAlign: "center",
              color: "#EA7C69",
              bgcolor: mode === "dark" ? "#181824" : "#fff",
              borderRadius: "16px 16px 0 0",
            }}
          >
            تعديل بيانات العميل
          </DialogTitle>
          <DialogContent
            dividers
            sx={{
              bgcolor: mode === "dark" ? "#232334" : "#fff",
              pb: 2,
            }}
          >
            <Grid container spacing={2} mt={1}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="اسم العميل"
                  name="customer_name"
                  value={form.customer_name || ""}
                  onChange={handleChange}
                  variant="outlined"
                  size={controlSize}
                  sx={{
                    bgcolor: mode === "dark" ? "#181824" : "#fff",
                    borderRadius: 2,
                    input: { color: mode === "dark" ? "#fff" : "#232334" },
                    label: { color: mode === "dark" ? "#aaa" : undefined },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="هاتف 1"
                  name="customer_phone1"
                  value={form.customer_phone1 || ""}
                  onChange={handleChange}
                  variant="outlined"
                  size={controlSize}
                  sx={{
                    bgcolor: mode === "dark" ? "#181824" : "#fff",
                    borderRadius: 2,
                    input: { color: mode === "dark" ? "#fff" : "#232334" },
                    label: { color: mode === "dark" ? "#aaa" : undefined },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="هاتف 2"
                  name="customer_phone2"
                  value={form.customer_phone2 || ""}
                  onChange={handleChange}
                  variant="outlined"
                  size={controlSize}
                  sx={{
                    bgcolor: mode === "dark" ? "#181824" : "#fff",
                    borderRadius: 2,
                    input: { color: mode === "dark" ? "#fff" : "#232334" },
                    label: { color: mode === "dark" ? "#aaa" : undefined },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="هاتف 3"
                  name="customer_phone3"
                  value={form.customer_phone3 || ""}
                  onChange={handleChange}
                  variant="outlined"
                  size={controlSize}
                  sx={{
                    bgcolor: mode === "dark" ? "#181824" : "#fff",
                    borderRadius: 2,
                    input: { color: mode === "dark" ? "#fff" : "#232334" },
                    label: { color: mode === "dark" ? "#aaa" : undefined },
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="العنوان 1"
                  name="customer_address1"
                  value={form.customer_address1 || ""}
                  onChange={handleChange}
                  variant="outlined"
                  size={controlSize}
                  sx={{
                    bgcolor: mode === "dark" ? "#181824" : "#fff",
                    borderRadius: 2,
                    input: { color: mode === "dark" ? "#fff" : "#232334" },
                    label: { color: mode === "dark" ? "#aaa" : undefined },
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="العنوان 2"
                  name="customer_address2"
                  value={form.customer_address2 || ""}
                  onChange={handleChange}
                  variant="outlined"
                  size={controlSize}
                  sx={{
                    bgcolor: mode === "dark" ? "#181824" : "#fff",
                    borderRadius: 2,
                    input: { color: mode === "dark" ? "#fff" : "#232334" },
                    label: { color: mode === "dark" ? "#aaa" : undefined },
                  }}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions sx={{ bgcolor: mode === "dark" ? "#232334" : "#fff", borderRadius: "0 0 16px 16px", px: { xs: 2, sm: 3 }, py: { xs: 1, sm: 1.25 } }}>
            <Button
              onClick={() => onClose(false)}
              variant="outlined"
              color="secondary"
              size={controlSize}
              sx={{
                minWidth: 100,
                borderColor: mode === "dark" ? "#888" : undefined,
                color: mode === "dark" ? "#fff" : undefined,
                px: { xs: 2, sm: 3 },
                py: { xs: 0.7, sm: 0.6 },
              }}
            >
              إلغاء
            </Button>
            <Button
              variant="contained"
              type="submit"
              size={controlSize}
              sx={{
                bgcolor: "#EA7C69",
                color: "#fff",
                minWidth: 120,
                fontWeight: 700,
                "&:hover": { bgcolor: "#d45d4c" },
                px: { xs: 3, sm: 4 },
                py: { xs: 0.8, sm: 0.7 },
                ml: 1,
              }}
            >
              حفظ التعديلات
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      <Snackbar open={!!error} autoHideDuration={3000} onClose={() => setError("")}>
        <Alert severity="error">{error}</Alert>
      </Snackbar>
      <Snackbar open={success} autoHideDuration={3000} onClose={() => setSuccess(false)}>
        <Alert severity="success">✅ تم التعديل بنجاح</Alert>
      </Snackbar>
    </>
  );
};

export default EditOrderForm;
